import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { CloudDeliveryType } from "@omni/types/api/product/cloud/shared/enums/deliveryType.enum";
import { AlgoliaSearchDeliveryType } from "@omni/types/api/search/algolia/product/shared/enums/deliveryType.enum";
import { BffSearchDeliveryType } from "@omni/types/api/search/bff/product/shared/enums/deliveryType.enum";

const fromCloudToBffMap: Record<CloudDeliveryType, DeliveryType> = {
    [CloudDeliveryType.ClickAndCollect]: DeliveryType.ClickAndCollect,
    [CloudDeliveryType.HomeDelivery]: DeliveryType.HomeDelivery
};

const fromBffToCloudMap: Record<DeliveryType, CloudDeliveryType> = {
    [DeliveryType.ClickAndCollect]: CloudDeliveryType.ClickAndCollect,
    [DeliveryType.HomeDelivery]: CloudDeliveryType.HomeDelivery
};

const fromAlgoliaSearchToBffMap: Record<
    AlgoliaSearchDeliveryType,
    DeliveryType
> = {
    [AlgoliaSearchDeliveryType.ClickAndCollect]: DeliveryType.ClickAndCollect,
    [AlgoliaSearchDeliveryType.HomeDelivery]: DeliveryType.HomeDelivery
};

const fromAlgoliaSearchToBffSearchMap: Record<
    AlgoliaSearchDeliveryType,
    BffSearchDeliveryType
> = {
    [AlgoliaSearchDeliveryType.ClickAndCollect]:
        BffSearchDeliveryType.ClickAndCollect,
    [AlgoliaSearchDeliveryType.HomeDelivery]: BffSearchDeliveryType.HomeDelivery
};

const fromBffToAlgoliaSearchMap: Record<
    DeliveryType,
    AlgoliaSearchDeliveryType
> = {
    [DeliveryType.ClickAndCollect]: AlgoliaSearchDeliveryType.ClickAndCollect,
    [DeliveryType.HomeDelivery]: AlgoliaSearchDeliveryType.HomeDelivery
};

const fromCloudToAlgoliaSearchMap: Record<
    CloudDeliveryType,
    AlgoliaSearchDeliveryType
> = {
    [CloudDeliveryType.ClickAndCollect]:
        AlgoliaSearchDeliveryType.ClickAndCollect,
    [CloudDeliveryType.HomeDelivery]: AlgoliaSearchDeliveryType.HomeDelivery
};

const fromBffSearchToBffMap: Record<BffSearchDeliveryType, DeliveryType> = {
    [BffSearchDeliveryType.ClickAndCollect]: DeliveryType.ClickAndCollect,
    [BffSearchDeliveryType.HomeDelivery]: DeliveryType.HomeDelivery
};

const fromBffSearchToAlgoliaSearchMap: Record<
    BffSearchDeliveryType,
    AlgoliaSearchDeliveryType
> = {
    [BffSearchDeliveryType.ClickAndCollect]:
        AlgoliaSearchDeliveryType.ClickAndCollect,
    [BffSearchDeliveryType.HomeDelivery]: AlgoliaSearchDeliveryType.HomeDelivery
};

const fromBffToBffSearchMap: Record<DeliveryType, BffSearchDeliveryType> = {
    [DeliveryType.ClickAndCollect]: BffSearchDeliveryType.ClickAndCollect,
    [DeliveryType.HomeDelivery]: BffSearchDeliveryType.HomeDelivery
};

const fromCloudToBffSearchMap: Record<
    CloudDeliveryType,
    BffSearchDeliveryType
> = {
    [CloudDeliveryType.ClickAndCollect]: BffSearchDeliveryType.ClickAndCollect,
    [CloudDeliveryType.HomeDelivery]: BffSearchDeliveryType.HomeDelivery
};

export const DeliveryTypeMapper = {
    fromCloudToBff: (deliveryType: CloudDeliveryType) =>
        fromCloudToBffMap[deliveryType],
    fromCloudToAlgoliaSearch: (deliveryType: CloudDeliveryType) =>
        fromCloudToAlgoliaSearchMap[deliveryType],
    fromCloudToBffSearch: (deliveryType: CloudDeliveryType) =>
        fromCloudToBffSearchMap[deliveryType],
    fromBffToCloud: (deliveryType: DeliveryType) =>
        fromBffToCloudMap[deliveryType],
    fromBffToAlgoliaSearch: (deliveryType: DeliveryType) =>
        fromBffToAlgoliaSearchMap[deliveryType],
    fromBffToBffSearch: (deliveryType: DeliveryType) =>
        fromBffToBffSearchMap[deliveryType],
    fromAlgoliaSearchToBff: (deliveryType: AlgoliaSearchDeliveryType) =>
        fromAlgoliaSearchToBffMap[deliveryType],
    fromAlgoliaSearchToBffSearch: (deliveryType: AlgoliaSearchDeliveryType) =>
        fromAlgoliaSearchToBffSearchMap[deliveryType],
    fromBffSearchToBff: (deliveryType: BffSearchDeliveryType) =>
        fromBffSearchToBffMap[deliveryType],
    fromBffSearchToAlgoliaSearch: (deliveryType: BffSearchDeliveryType) =>
        fromBffSearchToAlgoliaSearchMap[deliveryType]
};
